import React, { Fragment } from "react";
import { Link } from 'react-router-dom';


const Description = ()=> {

  return (
    <Fragment>
      <div className="description-overlay">
        <h5> Complete your first survey </h5>
        <p> Your input is valuable and we will reward you with up to <strong>10.000</strong> points for each finished survey. </p>
      </div>
      <Link className="btn action btn-primary" to={"/surveys"}>Start Survey</Link>
    </Fragment>
  );
};

export default Description;
